import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Col } from 'react-bootstrap';

export default class FooterNavigation extends Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    menuItemHoverStyle: PropTypes.object,
    textAlignment: PropTypes.oneOf(['left', 'center', 'right']),
    textColor: PropTypes.shape({
      primaryMenu: PropTypes.string,
      submenuFirstLevel: PropTypes.string,
      submenuSecondLevel: PropTypes.string,
    }),
    enableHideOnSmall: PropTypes.bool,
    enableSubmenu: PropTypes.bool,
    menu: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        href: PropTypes.string,
        target: PropTypes.string
      }).isRequired
    ).isRequired
  }

  static defaultProps = {
    textAlignment: 'left',
    backgroundColor: '#131c38',
    enableHideOnSmall: false,
    menuItemHoverStyle: {
      backgroundColor: '#222326',
      color: '#1db954',
      textDecoration: 'underline'
    },
    textColor: {
      primaryMenu: '#337ab7',
      submenuFirstLevel: '#FFF',
      submenuSecondLevel: '#999'
    },
    enableSubmenu: false
  }

  render() {
    const {
      menu,
      menuItemHoverStyle,
      textAlignment,
      textColor,
      backgroundColor,
      enableHideOnSmall,
      enableSubmenu
    } = this.props;

    const componentClassName = classNames('FooterNavigation frn-u-displayFont-sm', {'hidden-xs': enableHideOnSmall});

    return (
      <div className={componentClassName} style={{backgroundColor}}>
        <div className="container">
          <nav className="row">
            {menu.map((item, index) => (
              <MenuItem key={index} item={item} hoverStyle={menuItemHoverStyle} textAlignment={textAlignment} textColor={textColor} enableSubmenu={enableSubmenu}/>
            ))}
          </nav>
        </div>
      </div>
    );
  }
}

class MenuItem extends Component {
  static propTypes = {
    hoverStyle: PropTypes.object,
    textAlignment: PropTypes.string,
    textColor: PropTypes.object,
    item: PropTypes.object,
    enableSubmenu: PropTypes.bool
  }

  _renderSubmenu(item, index) {
    const {
      hoverStyle,
      textAlignment,
      textColor: {
        submenuFirstLevel: submenuFirstLevelTextColor,
        submenuSecondLevel: submenuSecondLevelTextColor
      },
      enableSubmenu
    } = this.props;

    const {
      text,
      target,
      href,
      menu: submenuSecondLevelItems = []
    } = item;

    if (!enableSubmenu) {
      return null;
    }

    return (
      <ul className="nav" key={index}>
        <Item text={text} target={target} href={href} hoverStyle={hoverStyle} textAlignment={textAlignment} textColor={submenuFirstLevelTextColor}/>
        {submenuSecondLevelItems.map((subItem, subIndex) => {
          const {
            text: subText,
            target: subTarget,
            href: subHref
          } = subItem;

          return (
            <Item key={subIndex} text={subText} target={subTarget} href={subHref} hoverStyle={hoverStyle} textAlignment={textAlignment} textColor={submenuSecondLevelTextColor} className="frn-u-displayFont-xs"/>
          );
        })}
      </ul>
    );
  }

  render() {
    const {
      hoverStyle,
      textAlignment,
      textColor: {
        primaryMenu: primaryMenuTextColor
      },
      item: {
        text,
        target,
        href,
        menu: submenuItems = []
      }
    } = this.props;

    return (
      <Col md={3} sm={4} xs={12} className="FooterNavigation-menu-column">
        <ul className="nav">
          <Item text={text} target={target} href={href} hoverStyle={hoverStyle} textAlignment={textAlignment} textColor={primaryMenuTextColor} className="FooterNavigation-menu-item frn-u-fontWeight-bold"/>
          {submenuItems.map((item, index) => this._renderSubmenu(item, index))}
        </ul>
      </Col>
    );
  }
}

class Item extends Component {
  static propTypes = {
    href: PropTypes.string,
    target: PropTypes.string,
    text: PropTypes.string,
    hoverStyle: PropTypes.object,
    textAlignment: PropTypes.string,
    textColor: PropTypes.string,
    className: PropTypes.string
  }

  state = {
    hover: false
  }

  render() {
    const {
      href,
      target,
      textAlignment,
      textColor,
      hoverStyle,
      text,
      className
    } = this.props;

    const {
      hover
    } = this.state;

    const style = {
      color: textColor,
      textAlign: textAlignment
    };

    if (hover) {
      _.assign(style, hoverStyle);
    }

    return (
      <li>
        <a onMouseEnter={() => this.setState({ hover: true })}
           onMouseLeave={() => this.setState({ hover: false })}
           className={className}
           href={href}
           style={style}
           target={target}>
           {text}
        </a>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/core/FooterNavigation.js